const React = require("react");
const PropTypes = require("prop-types");

const Row = ({ children }) => <div className="pane__list-row">{children}</div>;

Row.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Row;
